const app = {
  sidebarMountEl: '#js-sidebar-app',
  appMountEl: '#js-category-app',
  searchFilterMountEl: '#js-search-filter-app',
  allCategoriesMountEl: '#js-all-categories',
  facetsMountEl: '#js-facets-link',
  sortedProductListMountEl: '#js-sorted-product-list',
  favoriteButtonMountEl: '.js-favorite-button-wrapper',
  favoriteButtonPopupMountEl: '#js-favorite-btn-popup',
  columnMagazineSectionMountEl: '#js-cms-magazine-section',
  productQuickReview: '.js-product-quick-preview',
  productQuickPreviewModal: '#js-product-quick-preview-modal'
}

const data = {
  rootCategory: '#json-root-category',
  parentCategory: '#json-parent-category',
  childCategories: '#json-child-published-category',
  siblingCategories: '#json-sibling-published-category',
  productCategories: '#json-product-categories',
  shortestShippingDates: '#json-shortest-shipping-dates',
  maxQuantityPrice : '#max-quantity-price'
}

export { app, data }
